/** Alive Album — shared i18n until gallery-specific copy lands. */
import type { CatalogCardFieldKey } from '../../types';

export const moduleLabelKeys: Partial<Record<string, string>> = {};

export const groupLabelKeys: Partial<Record<string, string>> = {};

export const copyKeyAliases: Record<string, string> = {
  'platform.tab.tenants': 'platform.tab.tenants.alivealbum',
  'platform.tenantsHint': 'platform.tenantsHint.alivealbum',
  'platform.tenantCreate': 'platform.tenantCreate.alivealbum',
  'settings.sidebarContentFace': 'settings.sidebarContentFace.alivealbum',
  'settings.tabStorefront': 'settings.tabStorefront.alivealbum',
  'settings.storefrontHint': 'settings.storefrontHint.alivealbum',
  'settings.storefrontMenuItemsHintHost': 'settings.storefrontMenuItemsHintHost.alivealbum',
  'settings.storefrontMenuEnabledHint': 'settings.storefrontMenuEnabledHint.alivealbum',
  'settings.tabUiTemplates': 'settings.tabUiTemplates.alivealbum',
  'settings.uiPresetSection': 'settings.uiPresetSection.alivealbum',
  'settings.uiCloneSectionHint': 'settings.uiCloneSectionHint.alivealbum',
  'settings.uiPresetCatalogEmpty': 'settings.uiPresetCatalogEmpty.alivealbum',
  'settings.themeHint': 'settings.themeHint.alivealbum',
  'settings.themeBaseFontScaleHint': 'settings.themeBaseFontScaleHint.alivealbum',
  'settings.appearanceHint': 'settings.appearanceHint.alivealbum',
  'settings.appearancePreviewTitle': 'settings.appearancePreviewTitle.alivealbum',
  'settings.appearanceFocusOutlineHint': 'settings.appearanceFocusOutlineHint.alivealbum',
  'settings.appearanceSlotsEmpty': 'settings.appearanceSlotsEmpty.alivealbum',
  'settings.platformCardHint': 'settings.platformCardHint.alivealbum',
  'settings.platformCardPreviewHint': 'settings.platformCardPreviewHint.alivealbum',
  'settings.listOnPlatform': 'settings.listOnPlatform.alivealbum',
  'settings.listOnPlatformHint': 'settings.listOnPlatformHint.alivealbum',
  'settings.allowSearchIndexing': 'settings.allowSearchIndexing.alivealbum',
  'settings.allowSearchIndexingHint': 'settings.allowSearchIndexingHint.alivealbum',
  'settings.platformAdminLogin': 'settings.platformAdminLogin.alivealbum',
  'settings.platformAdminLoginHint': 'settings.platformAdminLoginHint.alivealbum',
  'legal.navTerms': 'legal.navTerms.alivealbum',
  'legal.terms.title': 'legal.terms.title.alivealbum',
  'legal.terms.body': 'legal.terms.body.alivealbum',
  'legal.navPrivacy': 'legal.navPrivacy.alivealbum',
  'legal.privacy.title': 'legal.privacy.title.alivealbum',
  'legal.privacy.body': 'legal.privacy.body.alivealbum',
  'legal.accessibility.title': 'legal.accessibility.title.alivealbum',
  'legal.accessibility.body': 'legal.accessibility.body.alivealbum',
  'legal.navCancel': 'legal.navCancel.alivealbum',
  'legal.cancel.title': 'legal.cancel.title.alivealbum',
  'legal.cancel.intro': 'legal.cancel.intro.alivealbum',
};

export const visibleCatalogCardFieldKeys: readonly CatalogCardFieldKey[] = [
  'name',
];

export const guestProfileLabelKey = 'nav.profile';

export const memberProfileLabelKey = 'nav.profile';
